import { useMutation } from '@tanstack/react-query';
import { getFile } from '../api/service.api';

export const useGetFile = () => {
    return useMutation({
        mutationFn: (vmId: number) => getFile(vmId),
    });
};
